import React, { useEffect, useRef } from "react";

/**
 * A dropdown popover anchored under its trigger. Renders `children` in a
 * scrollable card; closes on outside-click or Escape. The trigger button is
 * rendered by the caller (which owns the open state) — this only positions the
 * panel and handles dismissal.
 */
const DeviceToolsPopover = ({ open, onClose, children, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className={`absolute top-full z-30 mt-2 max-h-[70vh] w-[320px] overflow-y-auto rounded-xl border border-[#E5E7EB] bg-white p-3 shadow-xl ${
        className || "left-0"
      }`}
    >
      {children}
    </div>
  );
};

export default DeviceToolsPopover;
